export default "__VITE_ASSET__DQOgg8j$__"